import React, {PureComponent} from 'react'
import {inject, observer} from 'mobx-react'
import Store from 'Store'
import {CashDesk, Ticket, TicketCashDesk} from '../Model'
import {t, T} from 'helpers/i18n'
import {toMoney, toPercentage, toDateTime, toRound, toPorciento} from 'helpers/Format'
import TicketsReport from '../components/TicketsReport'
import {User} from '../../Users/Model'
import history from 'helpers/History'

interface Props {
  store?: Store
}

@inject('store')
@observer
class TicketGratis extends PureComponent<Props, object> {
  users: User[]
  componentDidMount() {
    console.log('TicketGratis - componentDidMount')
    this.props.store!.reports.readTicketGratis()
  }

  findUser = (lista, id: number) => {
    const result = lista.find(value => value.id === id)
    return result ? result.name : ''
  }

  handleOnSelectItem = (item) => {
    console.error((item as any).id)
    history.push(`/tickets/${item.id}`, item)
  }

  render() {
    const {reports} = this.props.store!
    const headers = ['businessUnit', 'operationLine', 'stretch', 'numero', 'user', 'datecheck', 'datevalited', 'discount', 'codeDiscount','terminal', 'netAmount', 'taxAmount',  'total']
    const items = reports.ticketGratis
    return (
      <TicketsReport
        onSelectItem={this.handleOnSelectItem}
        search
        header={headers}
        items={items}
        total={(tickets: Ticket[]) =>
          tickets.reduce((sum, item) => item.total + sum, 0)}
        loading={!reports.ticketGratisLoaded}
        keyExtractor={(ticket: Ticket) => String(ticket.id)}
        format={(tickets: Ticket[]) =>
          tickets.map(ticket => ({
            ...ticket,
            businessUnit: ticket.businessUnit,
            operationLine: ticket.operationLine,
            stretch: ticket.stretch,
            datecheck: toDateTime(ticket.datecheck),
            datevalited: ticket.datevalited? toDateTime(ticket.datevalited): t('sinValidar'),
            discount: toPorciento(ticket.discount),
            codeDiscount: ticket.codeDiscount,
            netAmount: toMoney(ticket.netAmount),
            taxAmount: toMoney(ticket.taxAmount),
            /*taxBase: toMoney(ticket.taxBase),*/
            total: toMoney(ticket.total),
            // user: ticket.user// this.findUser(this.props.store!.users.users, ticket.user_id)
            user: ticket.username
          }))}
      />
    )
  }
}

export default TicketGratis



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Reports/containers/TicketGratis.tsx